// extracted by mini-css-extract-plugin
module.exports = {"subtitleChart":"SubtitleChart_subtitleChart__3Cxrm","chartBlock":"SubtitleChart_chartBlock__1Mt3u","title":"SubtitleChart_title__sOzYP","text":"SubtitleChart_text__bE1zw"};